import { hasSaleSpecialForMenuType } from 'shared/helpers/specials';
import { observable, computed, action, toJS } from 'mobx';
import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';
import _isUndefined from 'lodash/isUndefined';
import _find from 'lodash/find';

export default class CartItem {
  /** @type {any} */
  @observable product = {
    Options: [],
    Prices: [],
  };
  @observable quantity = 0;
  @observable option = '';
  @observable id = null;

  constructor(cart, item, key) {
    this.cart = cart;
    this.product = item.product;
    this.quantity = Number(item.quantity);
    this.option = item.option;
    this.additionalOption = item.additionalOption;
    if (!item.additionalOption && item?.product?.AdditionalOptions?.[0]) {
      this.additionalOption = item?.product?.AdditionalOptions[0];
    }
    this.id = item.product?.id;
    this.key = key;
  }

  @action
  add(item) {
    if (this.product.id !== item.product.id || this.option !== item.option) {
      return;
    }
    this.quantity += item.quantity;
  }

  @computed
  get optionIndex() {
    return this.product.Options.indexOf(this.option);
  }

  @computed
  get basePrice() {
    return parseFloat((this.cart.isMedical ? this.product.medicalPrices : this.product.recPrices)[this.optionIndex]);
  }

  getBreakdownItem() {
    return _find(
      this.cart?.costBreakdown?.details || [],
      (detail) => this.id === detail.id && (this.option || `N/A`) === (detail.option || `N/A`)
    );
  }

  @computed
  get bogoDiscount() {
    const breakdownItem = this.getBreakdownItem();
    const bogoDiscount = breakdownItem?.bogoSavings?.menuBogoDiscount;
    return !_isNil(bogoDiscount) ? bogoDiscount : null;
  }

  @computed
  get discountToCartApplied() {
    const breakdownItem = this.getBreakdownItem();
    const isDiscountToCart = breakdownItem?.bogoSavings?.isDiscountToCartReward;
    return !_isNil(isDiscountToCart) ? isDiscountToCart : null;
  }

  @computed
  get discountedBasePrice() {
    if (hasSaleSpecialForMenuType({ product: this.product, medicalOrder: this.cart?.isMedical })) {
      return parseFloat(
        (this.cart.isMedical ? this.product.medicalSpecialPrices : this.product.recSpecialPrices)[this.optionIndex]
      );
    }
    return null;
  }

  @computed
  get individualPrice() {
    return !_isNil(this.discountedBasePrice) ? this.discountedBasePrice : this.basePrice;
  }

  @computed
  get price() {
    return this.unitPrice * this.quantity;
  }

  @computed
  get saleAdjustment() {
    const breakdownItem = _find(
      this.cart?.costBreakdown?.details || [],
      (detail) => this.id === detail.id && (this.option || `N/A`) === (detail.option || `N/A`)
    );
    return !_isNil(breakdownItem?.menuSaleAdjustment) ? breakdownItem?.menuSaleAdjustment : null;
  }

  @computed
  get unitPrice() {
    return this.discountedBasePrice || this.basePrice;
  }

  toJSON() {
    const product = toJS(this.product);
    product._id = product.id;
    return {
      product,
      quantity: this.quantity,
      option: this.option,
      additionalOption: this.additionalOption,
      basePrice: this.basePrice,
      discountedBasePrice: this.discountedBasePrice,
      price: this.price,
      key: this.key,
    };
  }
}
